import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'money',
    FormItemProps: {
      label: '金额',
      name: uuid,
    },
  }
};
